import React, { useEffect, useState, useRef } from "react";
import { CaretRightOutlined, RightOutlined, PrinterOutlined, EyeOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    DatePicker,
    Alert,
    notification,
    Typography,
    Space,
    Spin,
    Card,
    Avatar,
    Descriptions,
    Modal,
    Popconfirm
} from "antd";

import ProgrammeService from "../../api/programme.service";
import enrollmentService from "../../api/enrollment.service";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
import ReceiptHistoryComponent from "../enrollment/ReceiptHistoryComponent";
import commonUtility from "../../utility/Utils";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";
import moment from "moment";
const { TextArea } = Input;
const { Option } = Select;
const { Panel } = Collapse;

const defaultFormValues = {
    mode: "ADD",
    programme_id: 0,
    member_id: 0
};

const MemberDiscontinueEntry = () => {
    const [form] = Form.useForm();
    const formRef = useRef(null);
    const [programmeList, setProgrammeList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [enrollmentID, setEnrollmentID] = useState(0);
    const [memberID, setMemberID] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");
    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

   
    useEffect(() => {
        ProgrammeService.programmeListForScheduleReport().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeList(res.data.response_data);
            }
        });
    }, []);

    const onProgrammeChange = (id, object) => {
        setProgrammeID(id);
        setMemberList([]);
        getMemberList(object?.short_code)
    }
    const getMemberList = (short_code) => {

        form.setFieldsValue({
            member_search: '',
            member_id: ''
        });

        const data = {
            formdata: {
                programme_id: short_code
            }
        };

        ProgrammeService.memberListPromoted(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }

    const onSelectMember = (value) => {
        if (value > 0) {

            setMemberID(value);

            //  console.log(value);
            const data = { formdata: { member_id: value, programme_id: programmeID } };

            ProgrammeService.checkMemberEnrolement(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    const response = res.data.response_data;

                    setEnrollmentID(response.enrolmentData[0].enrollment_id);
                }
            });


        }

    };

    const onPaymentUptoChange = (date, dateString) => {
  
        form.setFieldsValue({
          last_paid_month : "" 
        });
    
        if(commonUtility.sanitizeObject(dateString) !="" ){
          const dateMoment = moment(date._d);
          const month = dateMoment.month();
          const year = dateMoment.year();
          const dt =  moment({ year, month }).startOf('month');
        //  console.log(dt.format('YYYY-MM-DD'));
          form.setFieldsValue({
            last_paid_month : dt.format('YYYY-MM-DD')
          });
          
        }    
    
      }

    const onMemberDiscontinueSave = async (values) => {
    //   console.log(values);
        const data = { formdata: {enrollment_id:enrollmentID,last_played_month:values.last_paid_month,note:values.notes} };
      
        setSaveLoaderEnable(true)

        enrollmentService.MemberDiscountinue(data).then((res) => {
           // console.log(res.data.response_status);
            if(res.data.response_status == SUCCESS_STATUS){
              const resp_data = res.data.response_data;     
              commonUtility.openNotificationWithType("success", "bottom","Message", "Successfully Saved");  
              formRef.current.resetFields();
              setMemberList([]);
              setEnrollmentID(0);
              setMemberID(0);
            //   setOpenModal(true)
            //   setResponseModalTitle("Sucess")
            //   setResponseModalMessage("Successfully Saved")       
            }else{
                commonUtility.openNotificationWithType("error", "bottomRight", "Error", res.data.response_msg);
            }   
                setSaveLoaderEnable(false)
        });            


    }

    return (
        <>
            
                    <Form
                        ref={formRef}
                        form={form}
                        layout="vertical"
                        onFinish={onMemberDiscontinueSave}
                        autoComplete="off"
                        // initialValues={defaultFormValues}
                    >                        
                        {/* <Form.Item name="mode" hidden={true}>
                          <Input type="text" />
                        </Form.Item> */}
                       
                            <Row gutter={10} >
                                <Col xs={24} xl={12} style={{ padding: "15px 20px" }}>
                                    <Row gutter={10} >
                                        <Col xs={24} xl={22}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Programme"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Programme is required',
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left"
                                                    onSelect={(value, event) =>
                                                        onProgrammeChange(value, event)
                                                    }  
                                                    defaultValue=""                                                
                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeList.length > 0
                                                        ? programmeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.programme_id}
                                                                value={programme_list.programme_id}
                                                                short_code={programme_list.short_code}
                                                            >
                                                                {programme_list.programme_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={15}>
                                            <Form.Item
                                                name="member_id"
                                                label="Member / Student"
                                                rules={[
                                                    {
                                                      required: true,
                                                      message: "Select Member / Student",
                                                    },
                                                  ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.includes(input)
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    onSelect={(value, event) =>
                                                        onSelectMember(value, event)
                                                    }
                                                    allowClear={true}
                                                >
                                                    {memberList.length > 0
                                                        ? memberList.map((member_list) => (
                                                            <Option
                                                                key={member_list.member_id}
                                                                value={member_list.member_id}
                                                            >
                                                                {`${member_list.member_fname} ${member_list.member_lname
                                                                    } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                                                        ? member_list.father_name
                                                                        : ""
                                                                    }`}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>

                                            </Form.Item>
                                        </Col>
                                        <Col className="gutter-row" xs={24} xl={7}>
                                            <Form.Item name="last_paid_month_picker" label="Last Played Month" rules={[
                                                    {
                                                        required: true,
                                                        message: 'Date is required',
                                                    },
                                                ]}>
                                                <DatePicker
                                                    // format={DATE_FORMAT_DMY_SLASH}
                                                    format="MM-YYYY"
                                                    onChange={onPaymentUptoChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    picker="month"
                                                />
                                            </Form.Item>
                                            <Form.Item name="last_paid_month" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={15}>
                                            <Form.Item name="notes" label="Note" rules={[
                                                    {
                                                        required: true,
                                                        message: 'Notes is required',
                                                    },
                                                ]}>
                                                <TextArea rows={2} placeholder="Enter notes" />
                                            </Form.Item>
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col xs={24} xl={24} style={{ textAlign: "center" }}>                                      
                                        <Form.Item label=" ">
                                          {  isSaveLoaderEnable ? <Spin /> : <>
                                                <Popconfirm
                                                    title="Data cann't be undone if discontinue. Do you want to discontinue? "
                                                    icon={
                                                        <QuestionCircleOutlined
                                                            style={{
                                                                color: 'red',
                                                            }}
                                                        />
                                                    }
                                                    onConfirm={()=>form.submit()}
                                                    // onCancel={cancel}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >

                                                    <Button
                                                        htmlType="button"
                                                        shape="round"
                                                        className="custom-button-green"
                                                    >
                                                        Save <RightOutlined />
                                                    </Button>
                                                </Popconfirm>
                                                </>
                                            }
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                </Col>
                                <Col xs={24} xl={12} style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px", padding: "14px 19px" }}>
                                    <Row gutter={20}>
                                        <ReceiptHistoryComponent
                                            //receiptHistoryList = {receiptHistoryList}
                                            enrollmentID={enrollmentID} memberID={memberID}
                                            yearID={commonUtility.getLoggedInUserInfo()?.yearID}
                                        />
                                    </Row>
                                </Col>

                            </Row>                    
                    </Form>
                
        </>
    )
}
export default MemberDiscontinueEntry;